// DRAWER JS

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.MenuDrawer');
  const openBtn = document.querySelector('.menu-drawer-toggle');
  const closeBtn = drawer.querySelector('.menu-drawer-close');
  const overlay = drawer.querySelector('.menu-drawer__overlay');

  // OPEN DRAWER
  openBtn.addEventListener('click', () => {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  });

  // CLOSE DRAWER
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    drawer.querySelectorAll('.submenu.is-active').forEach(s => s.classList.remove('is-active'));
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  // OPEN SUBMENU
  drawer.querySelectorAll('.menu-link.has-children').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = document.getElementById(btn.dataset.target);
      if (target) target.classList.add('is-active');
    });
  });

  // BACK BUTTONS
  drawer.querySelectorAll('.submenu-back').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.submenu').classList.remove('is-active');
    });
  });
});


// COLLECTION TAG BASED FILTER  
document.addEventListener("DOMContentLoaded", function () {
  function initAdvancedTagFilters() {
    document.querySelectorAll('.advanced-filters .advanced-filter').forEach(function (filterEl) {

      filterEl.addEventListener('click', function (e) {
        e.preventDefault();

        const link = this.querySelector('a');
        if (!link) return;

        const tagURL = link.getAttribute('href');
        if (!tagURL) return;
        this.parentElement.querySelectorAll('.advanced-filter').forEach(function (sibling) {
          sibling.classList.remove('active-filter');
        });

        this.classList.add('active-filter');

        document.body.classList.add('loading');

        fetch(tagURL, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(response => response.text())
          .then(responseHTML => {

            const parser = new DOMParser();
            const doc = parser.parseFromString(responseHTML, 'text/html');
            const newProducts = doc.querySelector('.ProductGridContainer')?.innerHTML
              || doc.querySelector('.grid--uniform')?.innerHTML;

            const productContainer =
              document.querySelector('.ProductGridContainer')
              || document.querySelector('.grid--uniform');

            if (newProducts && productContainer) {

              productContainer.innerHTML = newProducts;
              window.history.pushState({}, '', tagURL);
            }

            document.body.classList.remove('loading');

          })
          .catch(error => {
            console.error('Filter error:', error);
            document.body.classList.remove('loading');
          });

      });

    });
  }
  initAdvancedTagFilters();
});

// GRID COLLECTION 
document.addEventListener("DOMContentLoaded", function () {
  const gridContainer = document.querySelector(".ProductGridContainer");
  const buttons = document.querySelectorAll(".collection-toolbar .item");

  if (!gridContainer) return;

  const savedColumn = localStorage.getItem("selectedGridColumn");

  if (savedColumn) {
    gridContainer.classList.remove("grid-desktop-2", "grid-desktop-3", "grid-desktop-4");
    gridContainer.classList.add("grid-desktop-" + savedColumn);
    buttons.forEach(btn => {
      btn.classList.remove("active");
      if (btn.getAttribute("data-column") === savedColumn) {
        btn.classList.add("active");
      }
    });
  }

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const column = this.getAttribute("data-column");

      localStorage.setItem("selectedGridColumn", column);
      buttons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      gridContainer.classList.remove(
        "grid-desktop-2",
        "grid-desktop-3",
        "grid-desktop-4"
      );
      gridContainer.classList.add("grid-desktop-" + column);
    });
  });
});


// footer mobile accordion
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.footer-accordion-btn');

  function toggleAccordion() {
    const content = this.nextElementSibling;
    this.classList.toggle('active');
    content.classList.toggle('open');
  }

  function initAccordion() {
    if (window.innerWidth <= 989) {

      buttons.forEach((button, index) => {
        button.removeEventListener('click', toggleAccordion);
        button.addEventListener('click', toggleAccordion);

        if (index === 0) {
          button.classList.add('active');
          if (button.nextElementSibling) {
            button.nextElementSibling.classList.add('open');
          }
        } else {
          button.classList.remove('active');
          if (button.nextElementSibling) {
            button.nextElementSibling.classList.remove('open');
          }
        }
      });

    } else {
      buttons.forEach((button) => {
        button.removeEventListener('click', toggleAccordion);
        button.classList.remove('active');
        if (button.nextElementSibling) {
          button.nextElementSibling.classList.remove('open');
        }
      });
    }
  }

  initAccordion();
  window.addEventListener('resize', initAccordion);
});


// GoTo Top arrow
document.addEventListener('DOMContentLoaded', function () {
  "use strict";

  const progressWrap = document.querySelector('.progress-wrap');
  const progressPath = document.querySelector('.progress-wrap path');
  if (!progressWrap || !progressPath) return;

  const pathLength = progressPath.getTotalLength();

  progressPath.style.transition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = 'stroke-dashoffset 10ms linear';

  function updateProgress() {
    const scroll = window.scrollY;
    const height = document.documentElement.scrollHeight - window.innerHeight;
    progressPath.style.strokeDashoffset =
      pathLength - (scroll * pathLength) / height;
  }

  updateProgress();
  window.addEventListener('scroll', updateProgress);

  window.addEventListener('scroll', function () {
    progressWrap.classList.toggle('active-progress', window.scrollY > 1000);
  });

  progressWrap.addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
});




// RECOMMENDATIONS PRODUCT JS
document.addEventListener("DOMContentLoaded", function () {

  function SomeonePurchased() {

    const notification = document.querySelector(".product-notification");
    if (!notification) return;

    if (window.innerWidth <= 767) return;

    // Check cookie
    if (document.cookie.includes("pr_notification=closed")) {
      notification.remove();
      return;
    }

    const closeBtn = notification.querySelector(".closeNotify");

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        notification.remove();
        document.cookie = "pr_notification=closed; path=/; max-age=" + (60 * 60 * 24);
      });
    }

    const products = notification.querySelectorAll(".data-product");
    if (products.length === 0) return;

    const imgTag = notification.querySelector(".product-image img");
    const productName = notification.querySelector(".product-name");
    const productImageLink = notification.querySelector(".product-image");
    const timeAgo = notification.querySelector(".time-ago");
    const fromAgo = notification.querySelector(".from-ago");

    function toggleNotification() {

      if (notification.classList.contains("active")) {
        notification.classList.remove("active");
        return;
      }

      const randomIndex = Math.floor(Math.random() * products.length);
      const product = products[randomIndex];

      notification.classList.add("active");

      imgTag.src = product.dataset.image;
      productName.textContent = product.dataset.title;
      productName.href = product.dataset.url;
      productImageLink.href = product.dataset.url;
      timeAgo.textContent = product.dataset.time;
      fromAgo.textContent = product.dataset.local;
    }

    const delay = parseInt(notification.dataset.time) || 5000;

    let timer = setInterval(toggleNotification, delay);

    notification.addEventListener("mouseenter", function () {
      clearInterval(timer);
    });

    notification.addEventListener("mouseleave", function () {
      timer = setInterval(toggleNotification, delay);
    });

  }

  SomeonePurchased();
});


// product page popup 
document.addEventListener('DOMContentLoaded', function () {

  const productSection = document.querySelector('.main-product-section');
  document.querySelectorAll('modal-opener').forEach(function (opener) {
    opener.addEventListener('click', function () {
      const modalSelector = opener.getAttribute('data-modal');
      const modal = document.querySelector(modalSelector);

      if (modal) {
        modal.classList.add('active');
        if (productSection) {
          productSection.classList.add('overflow-hidden');
        }
      }
    });
  });

  document.querySelectorAll('.product-popup-modal__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const modal = btn.closest('.product-popup-modal');
      modal.classList.remove('active');
      if (productSection) {
        productSection.classList.remove('overflow-hidden');
      }
    });
  });
  document.querySelectorAll('.product-popup-modal').forEach(function (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('active');
        if (productSection) {
          productSection.classList.remove('overflow-hidden');
        }
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.product-popup-modal.active').forEach(function (modal) {
        modal.classList.remove('active');
      });
      if (productSection) {
        productSection.classList.remove('overflow-hidden');
      }
    }
  });

});

  // LANGUAGE country JS
  document.addEventListener('DOMContentLoaded', () => {
    const disclosures = document.querySelectorAll('.disclosure');
  
    disclosures.forEach(disclosure => {
      const button = disclosure.querySelector('.disclosure__button');
      const listWrapper = disclosure.querySelector('.disclosure__list-wrapper');
      const links = disclosure.querySelectorAll('.disclosure__link');
      const form = disclosure.closest('form');
  
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = button.getAttribute('aria-expanded') === 'true';
  
        closeAllDisclosures();
  
        if (!isOpen) {
          button.setAttribute('aria-expanded', 'true');
          listWrapper.hidden = false;
        }
      });
  
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const value = link.dataset.value;
          form.querySelector('input[name="locale_code"]').value = value;
          form.submit();
        });
      });
    });
  
    document.addEventListener('click', closeAllDisclosures);
  
    function closeAllDisclosures() {
      document.querySelectorAll('.disclosure__button').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.disclosure__list-wrapper').forEach(list => {
        list.hidden = true;
      });
    }
  });

// header cart count code
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(async (response) => {
      const url = arguments[0];
   
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {

        setTimeout(() => {
          fetch(window.location.href)
            .then(res => res.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newCount = doc.querySelector('#cart-icon-bubble').innerHTML;
              document.querySelector('#cart-icon-bubble').innerHTML = newCount;
            });
        }, 500);
      }
      return response;
    });
  };


  // mega menu js
(function () {
  const menus = document.querySelectorAll(
    '.header__inline-menu .mega-menu, .header__icons .localization-form details'
  );

  let closeTimer = null;

  menus.forEach((menu) => {
    const summary = menu.querySelector('summary');
    if (!summary) return;

    menu.open = false;

    menu.addEventListener('mouseenter', () => {
      if (window.innerWidth < 990) return;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }

      menus.forEach((other) => {
        if (other !== menu) {
          other.classList.remove('is-open');
          other.open = false;
        }
      });

      menu.open = true;
      menu.classList.add('is-open');
    });

    menu.addEventListener('mouseleave', () => {
      if (window.innerWidth < 990) return;

      menu.classList.remove('is-open');

      closeTimer = setTimeout(() => {
        menu.open = false;
        closeTimer = null;
      }, 300);
    });

    summary.addEventListener('click', (e) => {
      if (window.innerWidth >= 990) {
        e.preventDefault();
      }
    });
  });
})();


// open hover Header Language also open hover Header Country Form
document.addEventListener('DOMContentLoaded', function () {
  const disclosures = document.querySelectorAll('.localization-form .disclosure');

  disclosures.forEach((disclosure) => {
    const button = disclosure.querySelector('.disclosure__button');
    const dropdown = disclosure.querySelector('.disclosure__list-wrapper');

    if (!button || !dropdown) return;

    let hideTimeout;

    disclosure.addEventListener('mouseenter', () => {
      clearTimeout(hideTimeout);
      dropdown.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    });

    disclosure.addEventListener('mouseleave', () => {
      button.setAttribute('aria-expanded', 'false');

      hideTimeout = setTimeout(() => {
        dropdown.classList.remove('active');
      }, 120);
    });
  });
});

// parallax js
document.addEventListener('DOMContentLoaded', function () {
  gsap.registerPlugin(ScrollTrigger);
  const textElement = document.querySelector('[data-reveal-text]');
  if (!textElement) return;
  const content = textElement.innerHTML;
  const words = content.split(/(\s+)/);
  textElement.innerHTML = words
    .map((word) => {
      if (word.trim() === '') return word;
      return word
        .split('')
        .map((char) => {
          return `<div class="gsap_split_letter">${char}</div>`;
        })
        .join('');
    })
    .join('');

  const letters = textElement.querySelectorAll('.gsap_split_letter');
  gsap.to(letters, {
    opacity: 1,
    duration: 0.1, 
    stagger: 0.1,
    ease: 'none', 
    scrollTrigger: {
      trigger: textElement,
      start: 'top 70%', 
      end: 'bottom 40%', 
      scrub: 0.7, 
      markers: false,
    },
  });
});


// button hover animation
document.addEventListener('DOMContentLoaded', function () {
  function splitButtonText(root) {
    const searchRoot = root || document;
    const wrappers = searchRoot.querySelectorAll('.hover-text-wrapper');

    wrappers.forEach((wrapper) => {
      const textEl = wrapper.querySelector('.hover-hide');
      const target = wrapper.querySelector('.hover-show');

      if (!textEl || !target) return;

      const text = textEl.textContent.trim();

      target.innerHTML = '';

      text.split('').forEach((letter, i, arr) => {
        const span = document.createElement('span');
      
        span.style.setProperty('--i', i);
        span.style.setProperty('--total', arr.length);
      
        if (letter === ' ') {
          span.classList.add('letter-space');
          span.innerHTML = '&nbsp;';
        } else {
          span.textContent = letter;
        }
      
        target.appendChild(span);
      });
    });
  }

  splitButtonText();
  document.addEventListener('variant:change', () => splitButtonText());
  document.addEventListener('quick-view:loaded', function (e) {
    const wrapper = e.detail?.wrapper;
    if (wrapper) splitButtonText(wrapper);
  });
});
 
// -------------------------------- Countdown Timer -------------------------------- //
document.addEventListener("DOMContentLoaded", function () {
  initCountdown();
  observeCollectionChanges();
});

document.addEventListener("shopify:section:load", function () {
  initCountdown();
});

function initCountdown() {
  const timers = document.querySelectorAll(".sale-countdown");

  timers.forEach((timerEl) => {
    if (timerEl.classList.contains("initialized")) return;
    timerEl.classList.add("initialized");

    const endDate = timerEl.dataset.endDate;
    if (!endDate) return;

    const countDownDate = new Date(endDate).getTime();

    const daysEl = timerEl.querySelector(".days");
    const hoursEl = timerEl.querySelector(".hours");
    const minutesEl = timerEl.querySelector(".minutes");
    const secondsEl = timerEl.querySelector(".seconds");

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(interval);
        timerEl.innerHTML = "Sale Ended!";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((distance / (1000 * 60)) % 60);
      const seconds = Math.floor((distance / 1000) % 60);

      if (daysEl) daysEl.innerText = days;
      if (hoursEl) hoursEl.innerText = hours;
      if (minutesEl) minutesEl.innerText = minutes;
      if (secondsEl) secondsEl.innerText = seconds;
    }, 1000);
  });
}

function observeCollectionChanges() {
  const collectionContainer =
    document.querySelector("#ProductGridContainer") ||   
    document.querySelector("#product-grid") ||
    document.querySelector(".collection-grid") ||
    document.querySelector("[data-product-grid]") ||
    document.querySelector("main");                      

  if (!collectionContainer) return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        initCountdown();
        break;
      }
    }
  });

  observer.observe(collectionContainer, {
    childList: true,  
    subtree: true,    
  });
}

// -------------------------------- bundle products -------------------------------- //
(function () {
  'use strict';

  var __bundleObserverStarted = false;

  function getState() {
    try {
      var saved = localStorage.getItem('__bundleState');
      return saved ? JSON.parse(saved) : freshState();
    } catch (e) { return freshState(); }
  }

  function freshState() {
    return { active: false, totalSavingsCents: 0, discountTag: '', savingsPerItem: 0, variantIds: [] };
  }

  function saveState(state) {
    try { localStorage.setItem('__bundleState', JSON.stringify(state)); } catch (e) {}
    window.__bundleState = state;
  }

  window.__bundleState = getState();

  function getActiveCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active
      : 'USD';
  }

  /**
   * Format cents as a currency string using the store's active currency.
   * Used everywhere prices are displayed (product page bundle AND cart/drawer).
   *
   * @param {number} cents 
   * @returns {string}     
   */
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(getLocaleForCurrency(getActiveCurrency()), {
        style: 'currency',
        currency: getActiveCurrency(),
        minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {

      return getCurrencySymbol(getActiveCurrency()) + (cents / 100).toFixed(2);
    }
  }

  var formatMoneyBadge = formatMoney;

  function getLocaleForCurrency(currency) {
    var localeMap = {
      USD: 'en-US', CAD: 'en-CA', AUD: 'en-AU', GBP: 'en-GB',
      EUR: 'de-DE', INR: 'en-IN', JPY: 'ja-JP', CNY: 'zh-CN',
      BRL: 'pt-BR', MXN: 'es-MX', KRW: 'ko-KR', SGD: 'en-SG',
      CHF: 'de-CH', SEK: 'sv-SE', NOK: 'nb-NO', DKK: 'da-DK',
      NZD: 'en-NZ', ZAR: 'en-ZA', HKD: 'zh-HK', AED: 'ar-AE',
      SAR: 'ar-SA', THB: 'th-TH', MYR: 'ms-MY', IDR: 'id-ID',
      PHP: 'en-PH', TWD: 'zh-TW', TRY: 'tr-TR', PLN: 'pl-PL',
      CZK: 'cs-CZ', HUF: 'hu-HU', RON: 'ro-RO', ILS: 'he-IL',
      RUB: 'ru-RU', PKR: 'en-PK', BDT: 'bn-BD', VND: 'vi-VN'
    };
    return localeMap[currency] || 'en-US';
  }

  function getCurrencySymbol(currency) {
    var symbols = {
      USD: '$',  CAD: 'CA$', AUD: 'A$',  GBP: '£',  EUR: '€',
      INR: '₹',  JPY: '¥',  CNY: '¥',   BRL: 'R$', MXN: 'MX$',
      KRW: '₩',  SGD: 'S$', CHF: 'CHF', SEK: 'kr', NOK: 'kr',
      DKK: 'kr', NZD: 'NZ$',ZAR: 'R',  HKD: 'HK$',AED: 'AED',
      SAR: 'SAR',THB: '฿',  MYR: 'RM', IDR: 'Rp', PHP: '₱',
      TWD: 'NT$',TRY: '₺',  PLN: 'zł', CZK: 'Kč', HUF: 'Ft',
      RON: 'lei',ILS: '₪',  RUB: '₽',  PKR: '₨',  BDT: '৳',
      VND: '₫'
    };
    return symbols[currency] || (currency + ' ');
  }

  function injectStyles() {
    if (document.getElementById('bundle-badge-styles')) return;
    var style = document.createElement('style');
    style.id = 'bundle-badge-styles';
    style.textContent =
      '.bundle-discount-badge{}' +
      '.bundle-discount-badge__inner{display:flex;justify-content:space-between;align-items:center;}' +
      '.bundle-discount-badge__tag{font-size:13px;font-weight:700;color:#15803d;letter-spacing:0.5px;}' +
      '.bundle-discount-badge__savings{font-size:14px;font-weight:800;color:#15803d;}' +
      '.bundle-discount-badge__note{font-size:11px;color:#6b7280;margin:4px 0 0;}' +
      '.bundle-item-discount-row{display:flex;justify-content:space-between;align-items:center;margin:6px 0 2px;padding:4px 8px;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:4px;font-size:12px;font-weight:600;color:#15803d;width:100%;box-sizing:border-box;}' +
      '.bundle-item-discount-row__label{color:#15803d;font-size:11px;font-weight:700;letter-spacing:0.3px;}' +
      '.bundle-item-discount-row__amount{font-weight:800;font-size:12px;color:#15803d;}' +
      '.bundle-item__price-row{display:flex;align-items:center;gap:6px;flex-wrap:wrap;}' +
      '.bundle-item__price--original{margin: 0; text-decoration: line-through; margin-left: 0; color: var(--compare-price-color); }' +
      '.bundle-item__price--discounted{font-weight:800;color:#15803d;}' +
      '.bundle-item__price--current{font-size:14px;font-weight:700;color:#111827;}' +
      '.bundle-item__price--compare{text-decoration:line-through;color: var(--compare-price-color);font-size:12px;}';
    document.head.appendChild(style);
  }

  function injectBundleDiscountBadge(totalSavingsCents) {
    document.querySelectorAll('.bundle-discount-badge').forEach(function (el) { el.remove(); });
    if (totalSavingsCents <= 0) return;

    var targets = ['.totals', '.cart-drawer__footer', '.drawer__footer', '.cart__footer', '[data-cart-footer]', '.cart-footer'];
    var targetEl = null;
    for (var i = 0; i < targets.length; i++) {
      targetEl = document.querySelector(targets[i]);
      if (targetEl) break;
    }
    if (!targetEl) return;

    var badge = document.createElement('div');
    badge.className = 'bundle-discount-badge';
    targetEl.insertBefore(badge, targetEl.firstChild);
  }

  function injectPerItemDiscountRows(variantIds, _unused, offerText, discountPct) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {

        var priceMap = {};
        cart.items.forEach(function (item) {
          var isBundleItem = !!(item.properties && item.properties['_bundle_id']);
          priceMap[String(item.variant_id)] = {
            unitOrigPrice:  item.original_price,
            unitFinalPrice: item.final_price,
            lineOrigPrice:  item.original_line_price,
            lineFinalPrice: item.final_line_price,
            quantity:       item.quantity,
            isBundleItem:   isBundleItem,
            shopifyDiscountApplied: item.final_price < item.original_price
          };
        });

        var lineItemSelectors = [
          '.cart-item', '.cart-drawer__item', '.drawer__item',
          '[data-cart-item]', '.cart__item', 'li.mini-cart__item',
          'tr.cart-item', '[data-line-item]'
        ];
        var allLineItems = [];
        lineItemSelectors.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (allLineItems.indexOf(el) === -1) allLineItems.push(el);
          });
        });

        allLineItems.forEach(function (lineEl) {
          var vid = lineEl.dataset.variantId || lineEl.dataset.id || lineEl.dataset.productVariantId || '';
          if (!vid) {
            var vidEl = lineEl.querySelector('[data-variant-id]');
            if (vidEl) vid = vidEl.dataset.variantId || '';
          }
          if (!vid) {
            var hiddenInput = lineEl.querySelector('input[name="id"], input[name="variant_id"]');
            if (hiddenInput) vid = hiddenInput.value || '';
          }
          if (!vid) {
            lineEl.querySelectorAll('a[href]').forEach(function (a) {
              if (!vid) {
                var match = a.href.match(/variant[=:](\d+)/);
                if (match) vid = match[1];
              }
            });
          }

          var info = priceMap[String(vid)];

          if (!info) {
            var html = lineEl.innerHTML || '';
            if (html.indexOf('_bundle_id') !== -1 || html.indexOf('_bundle_label') !== -1 || html.indexOf('bundle_discount') !== -1) {
              for (var vi = 0; vi < variantIds.length; vi++) {
                if (priceMap[String(variantIds[vi])]) {
                  info = priceMap[String(variantIds[vi])];
                  break;
                }
              }
            }
          }

          if (!info || !info.isBundleItem) return;

          var unitOrigCents, unitFinalCents, lineOrigCents, lineFinalCents;
          if (info.shopifyDiscountApplied) {
            unitOrigCents  = info.unitOrigPrice;
            unitFinalCents = info.unitFinalPrice;
            lineOrigCents  = info.lineOrigPrice;
            lineFinalCents = info.lineFinalPrice;
          } else {
            unitOrigCents  = info.unitOrigPrice;
            unitFinalCents = Math.round(unitOrigCents * (1 - discountPct / 100));
            lineOrigCents  = info.lineOrigPrice;
            lineFinalCents = Math.round(lineOrigCents * (1 - discountPct / 100));
          }

          var priceEl = lineEl.querySelector('.cart-item__price, .price, .cart-item__final-price');
          if (priceEl && !priceEl.dataset.bundleDiscountApplied && unitOrigCents !== unitFinalCents) {
            priceEl.dataset.bundleDiscountApplied = '1';
            priceEl.innerHTML =
              '<span style="text-decoration: line-through; font-size: 14px; margin-right: 4px; color: var(--compare-price-color);">' + formatMoney(unitOrigCents) + '</span>' +
              '<span style="font-weight:800;color:#15803d;font-size:14px;">' + formatMoney(unitFinalCents) + '</span>';
          }

          var linePriceEl = lineEl.querySelector('[data-line-price]') ||
                            lineEl.querySelector('.cart-item__totals .price, .cart-item__price-wrapper .price, .totals__subtotal-value');
          if (linePriceEl && !linePriceEl.dataset.bundleDiscountApplied) {
            var existingContent = linePriceEl.innerHTML || '';
            var alreadyHasStrikethrough = existingContent.indexOf('<s>') !== -1 || existingContent.indexOf('line-through') !== -1;
            if (!alreadyHasStrikethrough && lineOrigCents !== lineFinalCents) {
              linePriceEl.dataset.bundleDiscountApplied = '1';
              linePriceEl.innerHTML =
                '<span style="text-decoration: line-through; font-size: 14px; margin-right: 4px; color: var(--compare-price-color);">' + formatMoney(lineOrigCents) + '</span>' +
                '<span style="font-weight:800;color:#15803d;font-size:14px;">' + formatMoney(lineFinalCents) + '</span>';
            }
          }

          var qbEl = lineEl.querySelector('.qb-total-line-item');
          if (qbEl && !qbEl.dataset.bundleDiscountApplied) {
            var qbHtml = qbEl.innerHTML || '';
            var qbAlreadyDiscounted = qbHtml.indexOf('qb-original-price') !== -1 || qbHtml.indexOf('qb-discounted-price') !== -1;
            if (qbAlreadyDiscounted) {
              qbEl.dataset.bundleDiscountApplied = '1';
            } else if (lineOrigCents !== lineFinalCents) {
              qbEl.dataset.bundleDiscountApplied = '1';
              qbEl.innerHTML =
                '<p style="text-decoration:line-through;font-size:14px;margin:0;color:var(--compare-price-color);">' + formatMoney(lineOrigCents) + '</p>' +
                '<p style="font-weight:700;color:#15803d;font-size:14px;margin:0;">' + formatMoney(lineFinalCents) + '</p>';
            } else {
              qbEl.dataset.bundleDiscountApplied = '1';
              qbEl.innerHTML = '<p style="font-weight:700;color:#15803d;font-size:14px;margin:0;">' + formatMoney(lineFinalCents) + '</p>';
            }
          }
        });
      })
      .catch(function () {});
  }

  function updateDisplayedSubtotalInstant(discountPct) {
    var state = window.__bundleState;
    if (!state || !state.active) return;

    var lineItems = document.querySelectorAll('.cart-item, .cart-drawer__item, [data-line-item]');
    var fullTotal = 0, bundleTotal = 0, bundleItemCount = 0;

    lineItems.forEach(function (lineEl) {
      var priceEl = lineEl.querySelector('.cart-item__price, .cart-item__final-price, [data-line-price], .qb-total-line-item');
      if (!priceEl) return;
      var raw = priceEl.textContent.replace(/[^0-9.]/g, '');
      var linePrice = raw ? Math.round(parseFloat(raw) * 100) : 0;
      fullTotal += linePrice;
      var text = lineEl.innerHTML;
      if (text.includes('_bundle_id') || text.includes('_bundle_label') || text.includes('bundle_discount')) {
        bundleTotal += linePrice;
        bundleItemCount++;
      }
    });

    var discount = bundleItemCount >= 3 ? Math.round(bundleTotal * discountPct / 100) : 0;
    var discountedTotal = fullTotal - discount;
    renderSubtotalEls(fullTotal, discountedTotal, discount);
  }

  function updateDisplayedSubtotal(discountPct, offerText, variantIds, savingsPerItem) {
    var state = window.__bundleState;
    if (!state || !state.active) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fullOriginalTotal = 0;
        var fullFinalTotal = cart.total_price;

        cart.items.forEach(function (item) {
          fullOriginalTotal += item.original_line_price;
        });

        var bundleGroups = {};
        cart.items.forEach(function (item) {
          var bId = item.properties ? item.properties['_bundle_id'] : null;
          if (!bId) return;
          if (!bundleGroups[bId]) bundleGroups[bId] = { origTotal: 0, finalTotal: 0, count: 0 };
          bundleGroups[bId].origTotal  += item.original_line_price;
          bundleGroups[bId].finalTotal += item.final_line_price;
          bundleGroups[bId].count      += item.quantity;
        });

        var bundleItemCount = 0;
        var totalDiscount = 0;

        for (var id in bundleGroups) {
          var group = bundleGroups[id];
          if (group.count >= 3) {
            var groupDiscount = group.origTotal - group.finalTotal;
            if (groupDiscount <= 0) {
              groupDiscount = Math.round(group.origTotal * discountPct / 100);
            }
            totalDiscount   += groupDiscount;
            bundleItemCount += group.count;
          }
        }

        if (bundleItemCount < 3) {
          saveState(freshState());
          document.querySelectorAll('.bundle-item-cart-banner').forEach(function (el) { el.remove(); });
          document.querySelectorAll('.bundle-discount-badge').forEach(function (el) { el.remove(); });
          document.querySelectorAll('[data-bundle-discount-applied]').forEach(function (el) {
            delete el.dataset.bundleDiscountApplied;
          });
          return;
        }

        var discountedTotal = fullFinalTotal;
        var discount = totalDiscount;
        var displayOriginal = fullOriginalTotal;
        var displayFinal    = fullFinalTotal;

        state.totalSavingsCents = discount;
        saveState(state);

        renderSubtotalEls(displayOriginal, displayFinal, discount);

        if (discount > 0) {
          injectBundleDiscountBadge(discount);
          setTimeout(function () {
            injectPerItemDiscountRows(state.variantIds, 0, offerText, discountPct);
          }, 100);
        }

        injectCartPagePrices(cart.items, discount, displayOriginal, displayFinal, discountPct);
      })
      .catch(function () {});
  }

  function renderSubtotalEls(fullTotal, discountedTotal, discount) {
    var originalEls = document.querySelectorAll('.bundle-subtotal__original');
    var finalEls = document.querySelectorAll('.bundle-subtotal__final');
    if (discount > 0 && fullTotal !== discountedTotal) {
      originalEls.forEach(function (el) { el.textContent = formatMoney(fullTotal); el.style.display = 'inline'; });
      finalEls.forEach(function (el) { el.textContent = formatMoney(discountedTotal); });
    } else {
      originalEls.forEach(function (el) { el.style.display = 'none'; });
      finalEls.forEach(function (el) { el.textContent = formatMoney(fullTotal); });
    }
  }

  function injectCartPagePrices() {}

  function reInjectBundleUI(discountPct, offerText) {
    var state = window.__bundleState;
    if (!state.active) return;
    injectBundleDiscountBadge(state.totalSavingsCents);
    setTimeout(function () {
      injectPerItemDiscountRows(state.variantIds, state.savingsPerItem, offerText, discountPct);
    }, 100);
    setTimeout(function () { updateDisplayedSubtotal(discountPct, offerText, state.variantIds, state.savingsPerItem); }, 300);
    setTimeout(function () { watchCartDrawerQuantities(discountPct, offerText); }, 500);
  }

  function startDrawerObserver(discountPct, offerText) {
    if (__bundleObserverStarted) return;
    __bundleObserverStarted = false;

    var targets = ['.cart-drawer__inner', '.drawer__inner', '#CartDrawer', '#cart-drawer', '.cart-drawer', 'body'];
    var targetEl = null;
    for (var i = 0; i < targets.length; i++) {
      targetEl = document.querySelector(targets[i]);
      if (targetEl) break;
    }
    if (!targetEl) return;

    new MutationObserver(function (mutations) {
      if (!window.__bundleState.active) return;
      var drawerOpened = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            n.classList && (n.classList.contains('cart-drawer') || n.classList.contains('is-open'))
          );
        }) || (m.target && m.target.classList && m.target.classList.contains('is-open'));
      });
      if (!document.querySelector('.bundle-discount-badge') || drawerOpened) {
        reInjectBundleUI(discountPct, offerText);
      }
    }).observe(targetEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function watchCartDrawerQuantities(discountPct, offerText) {
    var drawerSelectors = ['.cart-drawer', '#CartDrawer', '#cart-drawer', '.drawer', '.mini-cart', '[data-cart-drawer]'];
    var drawer = null;
    for (var i = 0; i < drawerSelectors.length; i++) {
      drawer = document.querySelector(drawerSelectors[i]);
      if (drawer) break;
    }
    if (!drawer || drawer.__bundleQtyWatching) return;
    drawer.__bundleQtyWatching = true;

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-minus],[data-quantity-plus],.quantity__button,.js-qty-btn,[name="minus"],[name="plus"],.cart-item__qty-button,.qb-qty-btn');
      if (!btn || !window.__bundleState.active) return;
      setTimeout(function () { updateDisplayedSubtotal(discountPct, offerText); }, 800);
      setTimeout(function () { updateDisplayedSubtotal(discountPct, offerText); }, 1500);
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="number"],.quantity__input,[data-cart-quantity]');
      if (!input || !window.__bundleState.active) return;
      setTimeout(function () { updateDisplayedSubtotal(discountPct, offerText); }, 1000);
    });
  }

  function openTannoraDrawer() {
    var already = document.querySelector('.cart-drawer.is-open, .drawer--open, #CartDrawer[open], #cart-drawer.active');
    if (already) return;
    var triggers = ['[data-cart-toggle]', '[data-open-cart]', '#cart-icon-bubble', 'a[href="/cart"].header__icon', '.cart-toggle', '.js-cart-toggle', 'a.header__icon--cart'];
    for (var i = 0; i < triggers.length; i++) {
      var el = document.querySelector(triggers[i]);
      if (el) { el.click(); return; }
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    window.dispatchEvent(new CustomEvent('cart:open'));
    document.querySelectorAll('#CartDrawer, #cart-drawer, .cart-drawer, .mini-cart, [data-cart-drawer]').forEach(function (el) {
      el.classList.remove('hidden', 'is-hidden', 'closed', 'is-closed', 'drawer--closed');
      el.classList.add('is-open', 'active', 'open', 'drawer--open');
      el.removeAttribute('hidden');
    });
  }

  function refreshAndOpenDrawer(totalSavingsCents, discountTag, isFullBundle, bundleVariantIds, savingsPerItem, offerText, discountPct) {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sectionsData) {
        var drawerHTML = sectionsData['cart-drawer'] || '';
        if (drawerHTML) {
          var parser = new DOMParser();
          var freshDoc = parser.parseFromString(drawerHTML, 'text/html');
          ['.cart-drawer__inner', '.drawer__inner', '[data-cart-drawer-content]', '#CartDrawer', '#cart-drawer'].forEach(function (sel) {
            var liveEl = document.querySelector(sel);
            var freshEl = freshDoc.querySelector(sel);
            if (liveEl && freshEl) liveEl.innerHTML = freshEl.innerHTML;
          });
        }

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart__count, .js-cart-count, .cart-count, #CartCount').forEach(function (el) { el.textContent = cart.item_count; });
            document.querySelectorAll('.cart-count-bubble').forEach(function (el) { el.classList.remove('hidden'); });
            if (isFullBundle && totalSavingsCents > 0) {
              injectBundleDiscountBadge(totalSavingsCents);
              setTimeout(function () { injectPerItemDiscountRows(bundleVariantIds, savingsPerItem, offerText, discountPct); }, 200);
            }
          });

        openTannoraDrawer();
      })
      .catch(function () {
        openTannoraDrawer();
        if (isFullBundle && totalSavingsCents > 0) {
          setTimeout(function () {
            injectBundleDiscountBadge(totalSavingsCents);
            injectPerItemDiscountRows(bundleVariantIds, savingsPerItem, offerText, discountPct);
          }, 300);
        }
      });
  }

  function initBundleSection(config) {
    var sectionId   = config.sectionId;
    var discountPct = config.discountPct;
    var offerText   = config.offerText;
    var btnText     = config.btnText;
    var productData = config.productData;
    var bundleLabel = 'bundle_discount_' + discountPct;

    var section = document.getElementById('bundle-section-' + sectionId);
    if (!section) return;

    section.querySelectorAll('[data-bundle-item]').forEach(function (item) {
      var minusBtn = item.querySelector('[data-qty-minus]');
      var plusBtn  = item.querySelector('[data-qty-plus]');
      var qtyInput = item.querySelector('[data-qty-input]');
      var checkbox = item.querySelector('.bundle-item__checkbox');

      if (minusBtn && plusBtn && qtyInput) {
        minusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10);
          if (val > 1) { qtyInput.value = val - 1; updateTotal(); }
        });
        plusBtn.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10);
          if (val < 99) { qtyInput.value = val + 1; updateTotal(); }
        });
        qtyInput.addEventListener('change', function () {
          var val = parseInt(qtyInput.value, 10);
          if (isNaN(val) || val < 1) qtyInput.value = 1;
          if (val > 99) qtyInput.value = 99;
          updateTotal();
        });
      }
      if (checkbox) {
        checkbox.addEventListener('change', function () {
          item.classList.toggle('is-unchecked', !this.checked);
          updateTotal();
        });
      }
    });

    section.querySelectorAll('[data-option-index]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var productIndex = parseInt(sel.dataset.productIndex, 10);
        var data = productData[productIndex];
        if (!data) return;
        var item = sel.closest('[data-bundle-item]');
        var selects = item.querySelectorAll('[data-option-index]');
        var selectedOptions = Array.from(selects).map(function (s) { return s.value; });
        var matched = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selectedOptions[i]; });
        });
        if (matched) {
          data.price = matched.price;
          if (matched.image) {
            var imgEl = item.querySelector('.bundle-item__image');
            if (imgEl) imgEl.src = matched.image;
          }
          updateTotal();
        }
      });
    });

    function updateTotal() {
      var totalWrap = document.getElementById('bundle-total-' + sectionId);
      if (!totalWrap) return;
      var originalEl = totalWrap.querySelector('.bundle-total__original');
      var finalEl    = totalWrap.querySelector('.bundle-total__final');
      var total = 0, checkedCount = 0;

      section.querySelectorAll('[data-bundle-item]').forEach(function (item, idx) {
        var checkbox = item.querySelector('.bundle-item__checkbox');
        if (checkbox && !checkbox.checked) return;
        checkedCount++;
        var data = productData[idx + 1];
        if (!data) return;
        var qty = parseInt(item.querySelector('[data-qty-input]').value, 10) || 1;
        total += data.price * qty;
      });

      var allChecked = (checkedCount === 3);

      section.querySelectorAll('[data-bundle-item]').forEach(function (item, idx) {
        var data = productData[idx + 1];
        if (!data) return;
        var priceRow = item.querySelector('.bundle-item__price-row');
        if (!priceRow) return;

        var unitPrice       = data.price;
        var discountedPrice = allChecked ? Math.round(unitPrice * (1 - discountPct / 100)) : unitPrice;

        priceRow.innerHTML = '';

        if (allChecked) {
          var origSpan = document.createElement('span');
          origSpan.className   = 'bundle-item__price--original';
          origSpan.textContent = formatMoney(unitPrice);   

          var discSpan = document.createElement('span');
          discSpan.className   = 'bundle-item__price--discounted';
          discSpan.textContent = formatMoney(discountedPrice);   
          priceRow.appendChild(origSpan);
          priceRow.appendChild(discSpan);
        } else {
          var currSpan = document.createElement('span');
          currSpan.className   = 'bundle-item__price--current';
          currSpan.textContent = formatMoney(unitPrice);   
          priceRow.appendChild(currSpan);

          var selects = item.querySelectorAll('[data-option-index]');
          var matched = null;
          if (selects.length > 0) {
            var selectedOptions = Array.from(selects).map(function (s) { return s.value; });
            matched = data.variants.find(function (v) {
              return v.options.every(function (o, i) { return o === selectedOptions[i]; });
            });
          } else {
            matched = data.variants[0];
          }
          if (matched && matched.compare_at_price && matched.compare_at_price > matched.price) {
            var cmpSpan = document.createElement('span');
            cmpSpan.className   = 'bundle-item__price--compare';
            cmpSpan.textContent = formatMoney(matched.compare_at_price);  
            priceRow.appendChild(cmpSpan);
          }
        }
      });

      var finalTotal = allChecked ? Math.round(total * (1 - discountPct / 100)) : total;
      if (allChecked) {
        originalEl.style.display = 'inline';
        originalEl.textContent = formatMoney(total);  
      } else {
        originalEl.style.display = 'none';
        originalEl.textContent = '';
      }
      finalEl.textContent = formatMoney(finalTotal);  
    }

    var addBtn = document.getElementById('bundle-add-btn-' + sectionId);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var desiredItems = [];
        var bundleTotalCents = 0;

        section.querySelectorAll('[data-bundle-item]').forEach(function (item, idx) {
          var checkbox = item.querySelector('.bundle-item__checkbox');
          if (checkbox && !checkbox.checked) return;
          var data = productData[idx + 1];
          if (!data) return;
          var qty = parseInt(item.querySelector('[data-qty-input]').value, 10) || 1;
          var selects = item.querySelectorAll('[data-option-index]');
          var matched = selects.length === 0
            ? data.variants[0]
            : data.variants.find(function (v) {
                var opts = Array.from(selects).map(function (s) { return s.value; });
                return v.options.every(function (o, i) { return o === opts[i]; });
              });
          if (matched) {
            bundleTotalCents += matched.price * qty;
            desiredItems.push({ id: matched.id, quantity: qty });
          }
        });

        var isFullBundle      = desiredItems.length === 3;
        var totalSavingsCents = isFullBundle ? Math.round(bundleTotalCents * discountPct / 100) : 0;
        var savingsPerItem    = 0;
        var discountTag       = 'BUY' + desiredItems.length + 'GET' + discountPct + '%OFF';
        var bundleVariantIds  = desiredItems.map(function (i) { return i.id; });

        var itemsWithProps = desiredItems.map(function (i) {
          var props = {
            '_bundle_id':    sectionId,
            '_bundle_label': bundleLabel
          };
          if (isFullBundle) {
            var unitSavings = 0;
            for (var pi in productData) {
              var pd = productData[pi];
              var matchedV = pd.variants.find(function (v) { return String(v.id) === String(i.id); });
              if (matchedV) {
                unitSavings = Math.round(matchedV.price * discountPct / 100);
                break;
              }
            }
            props['Bundle Deal'] = discountTag;
            props['You Save']    = formatMoney(unitSavings) + ' on this item';   
          }
          return { id: i.id, quantity: i.quantity, properties: props };
        });

        addBtn.disabled    = true;
        addBtn.textContent = 'Adding...';

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var changeRequests = [];
            var addItems       = [];

            itemsWithProps.forEach(function (desired) {
              var existingLine = null;
              for (var li = 0; li < cart.items.length; li++) {
                var cartItem = cart.items[li];
                var sameVariant  = String(cartItem.variant_id) === String(desired.id);
                var sameBundleId = cartItem.properties &&
                                   String(cartItem.properties['_bundle_id']) === String(sectionId);
                if (sameVariant && sameBundleId) {
                  existingLine = { index: li + 1, currentQty: cartItem.quantity };
                  break;
                }
              }
              if (existingLine) {
                changeRequests.push({ line: existingLine.index, quantity: existingLine.currentQty + desired.quantity });
              } else {
                addItems.push(desired);
              }
            });

            function runChanges(changes, done) {
              if (!changes.length) { done(); return; }
              var change = changes.shift();
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: change.line, quantity: change.quantity })
              })
              .then(function (r) { return r.json(); })
              .then(function () { runChanges(changes, done); })
              .catch(function () { runChanges(changes, done); });
            }

            function addNewItems(done) {
              if (!addItems.length) { done(); return; }
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: addItems })
              })
              .then(function (r) { return r.json(); })
              .then(function () { done(); })
              .catch(function () { done(); });
            }

            runChanges(changeRequests.slice(), function () {
              addNewItems(function () {
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    attributes: {
                      'bundle_discount_pct':  String(discountPct),
                      'bundle_discount_tag':  discountTag,
                      'bundle_total_savings': formatMoney(totalSavingsCents),   
                      'bundle_item_count':    String(desiredItems.length)
                    }
                  })
                })
                .then(function (r) { return r.json(); })
                .then(function () {
                  saveState({
                    active:            isFullBundle,
                    totalSavingsCents: totalSavingsCents,
                    discountTag:       discountTag,
                    savingsPerItem:    savingsPerItem,
                    variantIds:        bundleVariantIds
                  });
                  addBtn.textContent = '✓ Added!';
                  refreshAndOpenDrawer(totalSavingsCents, discountTag, isFullBundle, bundleVariantIds, savingsPerItem, offerText, discountPct);
                  setTimeout(function () { addBtn.disabled = false; addBtn.textContent = btnText; }, 2500);
                });
              });
            });
          })
          .catch(function (err) {
            console.error('Bundle add error:', err);
            addBtn.disabled    = false;
            addBtn.textContent = btnText;
            alert('Something went wrong. Please try again.');
          });
      });
    }

    updateTotal();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button');
    if (!btn || !window.__bundleState || !window.__bundleState.active) return;
    setTimeout(updateDisplayedSubtotalInstant.bind(null, window.__bundleState._discountPct || 20), 10);
    setTimeout(updateDisplayedSubtotalInstant.bind(null, window.__bundleState._discountPct || 20), 150);
    setTimeout(updateDisplayedSubtotal.bind(null, window.__bundleState._discountPct || 20, window.__bundleState._offerText || ''), 700);
  });

  document.addEventListener('cart:updated', function () {
    var state = window.__bundleState;
    if (state && state.active) {
      updateDisplayedSubtotal(state._discountPct || 20, state._offerText || '');
    }
  });

  function boot() {
    injectStyles();
    __bundleObserverStarted = false;

    var configs = window.BundleConfig || [];
    configs.forEach(function (config) {
      var state = window.__bundleState;
      state._discountPct = config.discountPct;
      state._offerText   = config.offerText;

      initBundleSection(config);
      startDrawerObserver(config.discountPct, config.offerText);
      watchCartDrawerQuantities(config.discountPct, config.offerText);

      if (state.active) {
        setTimeout(function () {
          injectBundleDiscountBadge(state.totalSavingsCents);
          setTimeout(function () {
            injectPerItemDiscountRows(state.variantIds, state.savingsPerItem, config.offerText, config.discountPct);
          }, 200);
        }, 500);
      }
    });

    ['cart:open', 'cart-drawer:open', 'drawer:open'].forEach(function (evtName) {
      document.addEventListener(evtName, function () {
        var state = window.__bundleState;
        if (!state || !state.active) return;
        setTimeout(function () {
          reInjectBundleUI(state._discountPct || 20, state._offerText || '');
        }, 300);
      });
    });

    document.querySelectorAll('.cart-drawer, #CartDrawer, #cart-drawer, .mini-cart').forEach(function (drawer) {
      new MutationObserver(function (mutations) {
        var state = window.__bundleState;
        if (!state || !state.active) return;
        mutations.forEach(function (m) {
          if (m.attributeName === 'class') {
            var isNowOpen = drawer.classList.contains('is-open') ||
                            drawer.classList.contains('active') ||
                            drawer.classList.contains('open');
            if (isNowOpen && !drawer.querySelector('.bundle-discount-badge')) {
              setTimeout(function () {
                reInjectBundleUI(state._discountPct || 20, state._offerText || '');
              }, 200);
            }
          }
        });
      }).observe(drawer, { attributes: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();


// -------------------------------- pdp review code -------------------------------- //

  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-link');
    const contents = document.querySelectorAll('.tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-tab');

        tabs.forEach((t) => t.classList.remove('active'));
        contents.forEach((c) => c.classList.remove('active'));

        tab.classList.add('active');
        document.getElementById(target).classList.add('active');
      });
    });
  });

    function openNotifyPopup() {
    document.getElementById("notify-popup").style.display = "flex";
  }

  function closeNotifyPopup() {
    document.getElementById("notify-popup").style.display = "none";
  }

 // -------------------------------- collection tag -------------------------------- //
 
   (function () {
          function syncClearButton() {
            var hasActive = document.querySelectorAll('.advanced-filter.active-filter').length > 0;
            var clearBtn = document.querySelector('.clear-tags');
            if (clearBtn) clearBtn.style.display = hasActive ? 'block' : 'none';
          }

          document.addEventListener('DOMContentLoaded', syncClearButton);
          document.addEventListener('shopify:section:load', syncClearButton);
          document.addEventListener('click', function (e) {
            var tagLink = e.target.closest('.advanced-filter a');
            if (tagLink) {
              var clearBtn = document.querySelector('.clear-tags');
              if (clearBtn) clearBtn.style.display = 'block';
            }
          });
        })();


// -------------------------------- Pagination Type -------------------------------- //

(function () {

  window.handlePaginationVisibility = function () {
    const grid = document.querySelector('.ProductGridContainer');
    if (!grid) return;

    const products = grid.children.length;
    const LIMIT = window.paginationSettings?.limit || 12;

    const defaultPagination = document.querySelector('.pagination');
    if (defaultPagination) {
      if (products < LIMIT) {
        defaultPagination.style.display = 'none';
        showNoMoreMessage(grid);
      } else {
        defaultPagination.style.display = '';
        document.querySelectorAll('.no-more-products-msg').forEach(el => el.remove());
      }
      return;
    }

    if (products < LIMIT) {
      document.querySelector('.load-more-wrapper')?.remove();
      document.querySelector('.infinite-scroll-trigger')?.remove();
      document.querySelector('.infinite-loading-indicator')?.remove();
      document.querySelectorAll('.no-more-products-msg').forEach(el => el.remove());
      showNoMoreMessage(grid);
    } else {
      document.querySelectorAll('.no-more-products-msg').forEach(el => el.remove());
    }
  };

  function showNoMoreMessage(referenceEl) {
    if (document.querySelector('.no-more-products-msg')) return;

    const msg = document.createElement('p');
    msg.className = 'no-more-products-msg';
    msg.textContent =
      window.collectionStrings?.noMoreProducts || 'There are no more items to load';

    referenceEl.insertAdjacentElement('afterend', msg);
  }

  function initLoadMoreBtn() {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    if (!loadMoreBtn || loadMoreBtn._bound) return;
    loadMoreBtn._bound = true;

    loadMoreBtn.addEventListener('click', async function () {
      const nextUrl = this.dataset.nextUrl;
      if (!nextUrl) return;

      this.disabled = true;
      this.classList.add('is-loading');
      this.innerHTML = `
        <span class="lm-spinner" aria-hidden="true"></span>
        <span class="lm-loading-text">Loading...</span>
      `;

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const grid = document.querySelector('.ProductGridContainer');
        doc.querySelectorAll('.ProductGridContainer > *').forEach(el => grid.appendChild(el));

        window.handlePaginationVisibility();

        const nextBtn = doc.querySelector('.load-more-btn');
        if (nextBtn?.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          loadMoreBtn.disabled = false;
          loadMoreBtn.classList.remove('is-loading');
          loadMoreBtn.innerHTML = `
            <div class="hover-hide">${loadMoreBtn.getAttribute('data-label') || 'Load More'}</div>
          `;
        } else {
          const wrapper = loadMoreBtn.closest('.load-more-wrapper');
          if (wrapper) {
            wrapper.style.transition = 'opacity 0.4s ease';
            wrapper.style.opacity = '0';
            setTimeout(() => {
              wrapper.remove();
              const g = document.querySelector('.ProductGridContainer');
              if (g) showNoMoreMessage(g);
            }, 400);
          }
        }

      } catch (err) {
        console.error('Load more failed:', err);
        loadMoreBtn.disabled = false;
        loadMoreBtn.classList.remove('is-loading');
        loadMoreBtn.innerHTML = `
          <div class="hover-hide">${loadMoreBtn.getAttribute('data-label') || 'Retry'}</div>
        `;
      }
    });
  }

  function initInfiniteScroll() {
    const infiniteTrigger = document.querySelector('.infinite-scroll-trigger');
    if (!infiniteTrigger || infiniteTrigger._observed) return;
    infiniteTrigger._observed = true;

    const indicator = document.createElement('div');
    indicator.className = 'infinite-loading-indicator';
    indicator.setAttribute('aria-live', 'polite');
    indicator.innerHTML = `
      <span class="lm-spinner" aria-hidden="true"></span>
      <span class="lm-loading-text">Loading more...</span>
    `;
    indicator.style.display = 'none';
    infiniteTrigger.parentNode.insertBefore(indicator, infiniteTrigger);

    let isFetching = false;
    let hasScrolled = false;

    window.addEventListener('scroll', () => { hasScrolled = true; }, { once: true, passive: true });

    const observer = new IntersectionObserver(async (entries) => {
      const entry = entries[0];
      if (!entry.isIntersecting || isFetching || !hasScrolled) return;

      const nextUrl = infiniteTrigger.dataset.nextUrl;
      if (!nextUrl) { observer.disconnect(); return; }

      isFetching = true;
      indicator.style.display = 'flex';

      try {
        const response = await fetch(nextUrl);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const grid = document.querySelector('.ProductGridContainer');
        doc.querySelectorAll('.ProductGridContainer > *').forEach(el => grid.appendChild(el));

        window.handlePaginationVisibility();

        const nextTriggerEl = doc.querySelector('.infinite-scroll-trigger');
        if (nextTriggerEl?.dataset.nextUrl) {
          infiniteTrigger.dataset.nextUrl = nextTriggerEl.dataset.nextUrl;
        } else {
          infiniteTrigger.removeAttribute('data-next-url');
          observer.disconnect();
          indicator.style.display = 'none';
          const g = document.querySelector('.ProductGridContainer');
          if (g) showNoMoreMessage(g);
        }

      } catch (err) {
        console.error('Infinite scroll fetch failed:', err);
      } finally {
        indicator.style.display = 'none';
        isFetching = false;
      }

    }, { rootMargin: '0px', threshold: 0.1 });

    observer.observe(infiniteTrigger);
  }


  function syncClearButton() {
    const hasActive = document.querySelectorAll('.advanced-filter.active-filter').length > 0;
    const clearBtn = document.querySelector('.clear-tags');
    if (clearBtn) clearBtn.style.display = hasActive ? 'block' : 'none';
  }

  let gridObserver = null;

  function observeGridChanges() {
    if (gridObserver) gridObserver.disconnect();

    const grid = document.querySelector('.ProductGridContainer');
    if (!grid) return;

    gridObserver = new MutationObserver(function () {
      clearTimeout(observeGridChanges._debounce);
      observeGridChanges._debounce = setTimeout(function () {
        window.handlePaginationVisibility();
        syncClearButton();
      }, 100);
    });

    gridObserver.observe(grid, { childList: true, subtree: false });
  }


  window.initPagination = function () {
    window.handlePaginationVisibility();
    syncClearButton();
    initLoadMoreBtn();
    initInfiniteScroll();
    observeGridChanges(); 
  };

  document.addEventListener('DOMContentLoaded', window.initPagination);
  document.addEventListener('shopify:section:load', window.initPagination);

  document.addEventListener('click', function (e) {
    const tagLink = e.target.closest('.advanced-filter a');
    if (!tagLink) return;

    const clearBtn = document.querySelector('.clear-tags');
    if (clearBtn) clearBtn.style.display = 'block';

    setTimeout(function () {
      window.handlePaginationVisibility();
      observeGridChanges();
    }, 300);
  });

})();

// -------------------------------- collection offere timer -------------------------------- //

(function () {

  const initialized = new WeakSet();

  function initCountdown(el) {
    if (initialized.has(el)) return; 
    initialized.add(el);

    const endTime = new Date(el.dataset.end).getTime();
    if (!endTime) return;

    const wrapper = el.closest('.countdown-wrapper');
    const expired = wrapper ? wrapper.querySelector('.countdown-expired') : null;

    const daysEl    = el.querySelector('.days');
    const hoursEl   = el.querySelector('.hours');
    const minutesEl = el.querySelector('.minutes');
    const secondsEl = el.querySelector('.seconds');

    function update() {
      const diff = new Date(el.dataset.end).getTime() - Date.now();

      if (diff <= 0) {
        el.style.display = 'none';
        if (expired) expired.style.display = 'block';
        clearInterval(timer);
        return;
      }

      const days    = Math.floor(diff / 864e5);
      const hours   = Math.floor((diff / 36e5) % 24);
      const minutes = Math.floor((diff / 6e4) % 60);
      const seconds = Math.floor((diff / 1e3) % 60);

      if (daysEl)    daysEl.textContent    = String(days).padStart(2, '0');
      if (hoursEl)   hoursEl.textContent   = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    update();
    const timer = setInterval(update, 1000);
  }

  function initAll(root = document) {
    root.querySelectorAll('.countdown-timer').forEach(initCountdown);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches('.countdown-timer')) {
          initCountdown(node);
        }

        node.querySelectorAll?.('.countdown-timer').forEach(initCountdown);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();



// Text with Product grid variant
document.querySelectorAll('.featured-slide').forEach(function (slide) {
  var link = slide.querySelector('.featured-grid-image');
  if (!link) return;

  var variants = [];
  try {
    variants = JSON.parse(link.getAttribute('data-product') || '[]');
  } catch (e) {
    return;
  }

  if (!variants.length) return;

  var primaryImg = slide.querySelector('.primary-img');
  var secondaryImg = slide.querySelector('.secondary-img');

  if (!primaryImg) return;

  var originalSrcset = primaryImg.getAttribute('srcset');
  var originalSrc = primaryImg.getAttribute('src');
  var origSecSrcset = secondaryImg ? secondaryImg.getAttribute('srcset') : null;
  var origSecSrc = secondaryImg ? secondaryImg.getAttribute('src') : null;
  var selectedOptions = {};

  if (variants.length && variants[0].options) {
    variants[0].options.forEach(function (val, idx) {
      selectedOptions[idx] = val;
    });
  }

  function findMatchedVariant() {
    var totalOptions = variants[0] ? variants[0].options.length : 0;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.options) continue;
      var match = true;
      for (var idx = 0; idx < totalOptions; idx++) {
        if (selectedOptions[idx] !== undefined && v.options[idx] !== selectedOptions[idx]) {
          match = false;
          break;
        }
      }
      if (match && v.available) return v;
    }

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.options) continue;
      var match = true;
      for (var idx = 0; idx < totalOptions; idx++) {
        if (selectedOptions[idx] !== undefined && v.options[idx] !== selectedOptions[idx]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }

    return null;
  }

  function updateSwatchStates() {
    slide.querySelectorAll('.variant-group').forEach(function (group) {
      var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);

      group.querySelectorAll('.variant-swatch').forEach(function (swatch) {
        var value = swatch.getAttribute('data-value');
        var isAvailable = variants.some(function (v) {
          if (!v.options || !v.available) return false;
          if (v.options[optionIndex] !== value) return false;

          for (var idx in selectedOptions) {
            if (parseInt(idx) === optionIndex) continue;
            if (v.options[idx] !== selectedOptions[idx]) return false;
          }
          return true;
        });

        swatch.classList.toggle('active', selectedOptions[optionIndex] === value);
        swatch.classList.toggle('unavailable', !isAvailable);
        swatch.disabled = !isAvailable;
      });
    });
  }

  function applyVariantImage(matched) {
    if (matched && matched.featured_image) {
      var imgSrc = matched.featured_image.src;
      var sized = imgSrc
        .replace(/(_\d+x\d*|_\d*x\d+)(\.(?:jpg|jpeg|png|gif|webp))/i, '$2')
        .replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_800x$1$2');

      primaryImg.src = sized;
      primaryImg.srcset = '';

      if (secondaryImg) {
        secondaryImg.src = origSecSrc || sized;
        secondaryImg.srcset = origSecSrcset || '';
      }
    } else {
      primaryImg.src = originalSrc;
      primaryImg.srcset = originalSrcset || '';
      if (secondaryImg) {
        secondaryImg.src = origSecSrc || '';
        secondaryImg.srcset = origSecSrcset || '';
      }
    }
  }

  slide.querySelectorAll('.variant-group').forEach(function (group) {
    var optionIndex = parseInt(group.getAttribute('data-option-index'), 10);

    group.querySelectorAll('.variant-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.preventDefault();

        selectedOptions[optionIndex] = swatch.getAttribute('data-value');

        var matched = findMatchedVariant();

        applyVariantImage(matched);
        updateSwatchStates();

        if (matched) {
          var form = slide.querySelector('.ajax-add-to-cart-form input[name="id"]');
          if (form) form.value = matched.id;

          var quickAddBtn = slide.querySelector('.quick-add__submit');
          if (quickAddBtn) {
            quickAddBtn.setAttribute('data-modal', '#QuickAdd-' + matched.id);
            quickAddBtn.setAttribute('data-product-url', matched.url || '');
          }
        }
      });
    });
  });

  updateSwatchStates();
});

// Text with Product grid section product animation scroll

(function () {
  function init() {
    const section = document.querySelector('.text-product-grid');
    if (!section) return;

    const imageProducts = section.querySelector('.image-products');
    const circleBorder = section.querySelector('.circle-border');
    const plusIcon = section.querySelector('.plus-icon');
    const impactCard = section.querySelector('.impact-product-card');
    const featuredSlides = Array.from(section.querySelectorAll('.featured-slide'));

    if (!circleBorder || !imageProducts || !featuredSlides.length) return;

    const firstRect = featuredSlides[0].getBoundingClientRect();
    const lastRect = featuredSlides[featuredSlides.length - 1].getBoundingClientRect();
    const slideRange = lastRect.top - firstRect.top;

    const BASE_Y = -223;
    const SCALE_START = 1.0;
    const SCALE_MID = 0.6;
    const SCALE_END = 0.3;
    const HIDE_AT = 0.85;
    const LEFT_RESET_AT_Y = 269.458;
    const SCALE_RESET_AT_Y = 363.558;
    const FREEZE_AT_Y = 623.021;

    function setCardSize(active) {
      if (!impactCard) return;

      if (active) {
        impactCard.style.width = '';
        impactCard.style.height = '';
      } else {
        impactCard.style.width = '';
        impactCard.style.height = '';
      }
    }

    let ticking = false;

    function update() {
      const sectionRect = imageProducts.getBoundingClientRect();
      const windowH = window.innerHeight;

      const maxScroll = sectionRect.height - windowH;

      if (maxScroll <= 0) {
        ticking = false;
        return;
      }

      const progress = Math.max(0, Math.min(1, -sectionRect.top / maxScroll));
      const translateY = BASE_Y + progress * slideRange;

      function activateReveal() {
        circleBorder.style.visibility = 'hidden';
        circleBorder.style.opacity = '0';
        circleBorder.style.pointerEvents = 'none';

        if (featuredSlides[0]) {
          featuredSlides[0].style.visibility = 'visible';
        }

        setCardSize(true);
      }

      function resetReveal() {
        circleBorder.style.visibility = 'visible';
        circleBorder.style.opacity = '1';
        circleBorder.style.pointerEvents = 'auto';

        if (featuredSlides[0]) {
          featuredSlides[0].style.visibility = 'hidden';
        }
      }

      if (translateY >= FREEZE_AT_Y) {
        circleBorder.style.transform =
          `translateY(576.15px) scale(1) rotate(0deg)`;

        circleBorder.style.left = '145px';

        if (plusIcon) plusIcon.style.display = 'none';

        activateReveal();

        ticking = false;
        return;
      }

      circleBorder.style.left =
        translateY >= LEFT_RESET_AT_Y ? '80px' : '10px';

      if (translateY >= SCALE_RESET_AT_Y) {
        circleBorder.style.transform =
          `translateY(576.15px) scale(1) rotate(0deg)`;

        circleBorder.style.left = '145px';

        if (plusIcon) plusIcon.style.display = 'none';

        activateReveal();

        ticking = false;
        return;
      } else {
        if (plusIcon) plusIcon.style.display = '';

        setCardSize(false);
        resetReveal();
      }

      if (progress >= HIDE_AT) {
        circleBorder.style.opacity = '0';
        circleBorder.style.pointerEvents = 'none';
        circleBorder.style.visibility = 'hidden';

        ticking = false;
        return;
      } else {
        circleBorder.style.opacity = '1';
        circleBorder.style.pointerEvents = 'auto';
        circleBorder.style.visibility = 'visible';
      }

      let scale;

      if (progress < 0.5) {
        const t = progress / 0.5;

        scale =
          SCALE_START - t * (SCALE_START - SCALE_MID);
      } else {
        const t = (progress - 0.5) / (HIDE_AT - 0.5);

        scale =
          SCALE_MID - t * (SCALE_MID - SCALE_END);
      }

      circleBorder.style.transform =
        `translateY(${translateY}px) scale(${scale}) rotate(-30deg)`;

      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', update);

    update();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();


// product card variant
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.variant-swatch');
  if (!swatch) return;

  const productCard = swatch.closest('.featured-slide');
  if (!productCard) return;

  const imageWrapper  = productCard.querySelector('.featured-grid-image');
  const mainImage     = imageWrapper.querySelector('[data-main-image]');
  const variants      = JSON.parse(imageWrapper.dataset.product || '[]');

  const priceSaleEl    = productCard.querySelector('.price-sale');
  const priceCompareEl = productCard.querySelector('.price-compare');
  const priceRegularEl = productCard.querySelector('.price-regular');
  const priceFromEl    = productCard.querySelector('.price-from');
  const variantInput   = productCard.querySelector('.ajax-add-to-cart-form input[name="id"]');

  const group = swatch.closest('.variant-group');
  group.querySelectorAll('.variant-swatch').forEach(btn => btn.classList.remove('active'));
  swatch.classList.add('active');

  const selected = [];
  productCard.querySelectorAll('.variant-group').forEach((g) => {
    const active = g.querySelector('.variant-swatch.active');
    selected.push(active ? active.dataset.value : null);
  });

  const match = variants.find(v =>
    selected.every((val, i) => !val || v[`option${i + 1}`] === val)
  );

  if (!match) return;

  if (match.featured_image?.src) {
    mainImage.src = match.featured_image.src.split('?')[0] + '?width=600';
  }

  const fmt = (paise) =>
    new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(paise / 100);

  const price   = match.price;
  const compare = match.compare_at_price;

  if (priceFromEl)    priceFromEl.textContent    = fmt(price);
  if (priceRegularEl) priceRegularEl.textContent  = fmt(price);
  if (priceSaleEl)    priceSaleEl.textContent     = fmt(price);
  if (priceCompareEl) priceCompareEl.textContent  = compare ? fmt(compare) : ''; 

  if (variantInput) variantInput.value = match.id;
});  
    // more descriotion in product page
                    function toggleDesc(el) {
                      const wrapper = el.closest('.product__description-wrapper');
                      const shortDesc = wrapper.querySelector('.short-desc');
                      const fullDesc = wrapper.querySelector('.full-desc');

                      if (fullDesc.classList.contains('open')) {
                        fullDesc.style.height = fullDesc.scrollHeight + 'px';
                        requestAnimationFrame(() => {
                          fullDesc.style.height = '0px';
                        });

                        fullDesc.classList.remove('open');
                        shortDesc.classList.remove('hide');
                      } else {
                        shortDesc.classList.add('hide');

                        fullDesc.style.display = 'block';
                        const height = fullDesc.scrollHeight;

                        fullDesc.style.height = '0px';

                        requestAnimationFrame(() => {
                          fullDesc.style.height = height + 'px';
                        });

                        fullDesc.classList.add('open');
                      }
                    }

// pdp review code
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tab-link');
    const contents = document.querySelectorAll('.tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-tab');

        tabs.forEach((t) => t.classList.remove('active'));
        contents.forEach((c) => c.classList.remove('active'));

        tab.classList.add('active');
        document.getElementById(target).classList.add('active');
      });
    });
  });

   // collection banner js
    document.addEventListener('DOMContentLoaded', () => {
    const items = document.querySelectorAll('.collection-faqs .accordion-item');

    items.forEach((item) => {
      const header = item.querySelector('.accordion-header');
      const content = item.querySelector('.accordion-content');

      header.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        items.forEach((otherItem) => {
          otherItem.classList.remove('active');
          otherItem.querySelector('.accordion-content').style.maxHeight = null;
        });

        if (!isActive) {
          item.classList.add('active');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });